import att from './../assets/at&t.png';
import underdog from './../assets/underdogventures.png';
import primeTime from './../assets/PrimeTime.png';
import flordecaña from './../assets/flordecaña.png';
import marck from './../assets/marc.png';
import messi from './../assets/messi.png';
import nissan from './../assets/nissan.png';
import unidos from './../assets/UnidosUS.png';

export const logos = [
    {
        id: 1,
        title: 'UnidosUS',
        img: unidos,
    },
    {
        id: 2,
        title: 'Primetime',
        img: primeTime,
    },
    {
        id: 3,
        title: 'Underdog',
        img: underdog,
    },
    {
        id: 4,
        title: 'Mas+',
        img: messi,
    },
    {
        id: 5,
        title: 'Mark Anthony',
        img: marck,
    },
    {
        id: 6,
        title: 'Nissan',
        img: nissan,
    },
    {
        id: 7,
        title: 'Flor de caña',
        img: flordecaña,
    },
    {
        id: 8,
        title: 'AT&T',
        img: att,
    },
];